import Joi from 'joi'
import AbstractModel from './AbstractModel'

export default class ClientScopeModel extends AbstractModel {
  constructor (data) {
    super(data)
    Object.freeze(this)
  }

  static get schema () {
    return {
      scope: Joi.string().required(),
      role: Joi.string().required(),
      resourceString: Joi.string().required(),
      description: Joi.string().required()
    }
  }

  static fromJs (data) {
    return new ClientScopeModel(data, { stripUnknown: true })
  }
}
